const queries = {
  user: () => ['user'],
  status: () => ['status'],
  profile: () => ['profile'],
  translationList: () => ['translation/list'],
  loginSettings: () => ['login-settings'],

  // Consent
  activeConsent: () => ['active-consent'],

  // Ecom-policy
  policyList: () => ['policy/list'],
  policy: (policyId: number) => ['policy', policyId],
  mandatoryProducts: (policyId: number, selectedProductIds: number[]) => [
    'mandatory-products',
    policyId,
    ...selectedProductIds,
  ],
  order: (orderId: number) => ['order', orderId],
  greenpoolOrder: (orderId: number) => ['greenpool-order', orderId],

  injuryReportAssets: () => ['injury-reports/assets'],
  injuryReport: (id: number) => ['injury-reports', id],

  buyout: () => ['buyout'],

  // Subscription services
  subscriptionServicesList: () => ['subscription-services-list'],

  // Activities
  activities: () => ['activities'],
  activity: (activityId: number) => ['activity', activityId],
  notifications: () => ['notifications'],
  carrierbyid: () => ['carrierById'],
}

export default queries
